import type React from "react";

import { DynamicRepeaterItemOverlay } from "@/components/DynamicRepeater/DynamicRepeaterItemOverlay";

interface SurveyRespondQuestionCardDynamicRepeaterItemOverlayProps {
  title: string;
  description?: string;
}

export function SurveyRespondQuestionCardDynamicRepeaterItemOverlay({
  title,
  description,
}: SurveyRespondQuestionCardDynamicRepeaterItemOverlayProps): React.ReactNode {
  return (
    <DynamicRepeaterItemOverlay show title={title}>
      {description && <p className="text-body text-text-secondary">{description}</p>}
    </DynamicRepeaterItemOverlay>
  );
}
